module.exports = __webpack_public_path__ + "img/icon-praticidade.592c972f.png";